import React from 'react';
import type { IconProps } from '../types';

export const NavigationPanelReveal = (props: IconProps) => (
  <svg
    width="60"
    height="30"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Rectangle around the "+" symbol with green color */}
    <rect
      x="0"
      y="5" // Adjusted to center the box vertically
      width="14"
      height="20"
      fill="green" // Set the box color to green
      stroke="currentColor"
      strokeWidth="2"
      rx="4" // Optional: rounded corners
    />
    {/* Text "+" inside the box */}
    <text
      x="7"
      y="15" // Now centered vertically and horizontally
      fontFamily="Arial, sans-serif"
      fontSize="16"
      fill="currentColor"
      dominantBaseline="middle"
      textAnchor="middle" // Center the text horizontally
    >
      +
    </text>
  </svg>
);

export default NavigationPanelReveal;
